import { v4 as uuidv4 } from 'uuid';

/**
 * Processes mapping data to create an array of page config objects.
 * @param {object} mapping - Mapping data from the couchbase doc
 * @returns {Array} Array of processed page config objects.
 */
const getProcessedConfigDataFromMapping = (mapping) => {
	const configArr = [];
	for (const pageUrl in mapping) {
		const videos = mapping[pageUrl].map((video) => {
			const { src: videoUrl, type: videoType } = video.sources[0];
			const numberOfTimes = video.numberOfTimes ?? 1;
			const { thumbnail, description, ctaType, videoLvlCtaDetails } = video;
			return {
				videoUrl,
				videoType,
				numberOfTimes,
				thumbnail,
				description,
				ctaType,
				videoLvlCtaDetails
			};
		});

		configArr.push({
			id: uuidv4(),
			pageUrl,
			videos
		});
	}
	return configArr;
};

/**
 * Creates a new page config object with default values.
 * @returns {object} New page config object.
 */
const getNewPageObject = () => {
	return {
		id: uuidv4(),
		pageUrl: '',
		videos: [
			{
				videoUrl: '',
				videoType: 'application/x-mpegURL',
				numberOfTimes: 1,
				thumbnail: '',
				description: ''
			}
		],
		isDeletable: true
	};
};

/**
 * Creates a new video config object with default values.
 * @returns {object} New video config object.
 */
const getNewVideoObject = () => {
	return {
		videoUrl: '',
		videoType: 'application/x-mpegURL',
		numberOfTimes: 1,
		thumbnail: '',
		description: ''
	};
};

export { getProcessedConfigDataFromMapping, getNewPageObject, getNewVideoObject };
